export default `---
slug: honduras
country: Honduras
countryCode: HND
continent: America
year: 2014
title: "Honduras"
description: "A cruise ship stop with stunning coastline and the warmth of Central America."
thumbnail: /images/travels/HND/honduras_thumb.jpg
relatedLinks: []
---
![honduras](/images/travels/HND/honduras_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Honduras and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
